import { ICON } from '@george-labs.com/george-assets/icons';

export const getIconHtml = (
    icon: string,
    iconClassName = '',
    htmlTitle?: string,
    htmlTooltip?: boolean,
    isBodyContainer?: boolean,
): string => {
    let title = htmlTitle ? ` title="${htmlTitle}" ` : '';

    if (htmlTooltip) {
        title += ' data-html="true"';
    }

    return `
            <svg
              ${title}
              class="ico-${icon} ${iconClassName}"
              ${isBodyContainer ? ' data-container="body" ' : ''}
            >
              <use
                xmlns:xlink="http://www.w3.org/1999/xlink"
                xlink:href="#ico-${icon}"
              ></use>
            </svg>
          `;
};

export const translateIconToStyleGuideIcon = (icon?: string): ICON | undefined => {
    if (!icon) {
        return undefined;
    }

    const translatedName = icon.toUpperCase().replace(/-/g, '_');

    return ICON[translatedName as keyof typeof ICON] || icon;
};
